import { getProjectIdFromNodeId } from '@/features/projects/utils/projectUtils';

export function resolveCreateOperationProjectId(options: {
  explicitProjectId?: string;
  parentId?: string;
  activeProjectId?: string;
  hasMultipleVisibleProjects: boolean;
}): string | undefined {
  const normalizedActiveProjectId =
    typeof options.activeProjectId === 'string' && options.activeProjectId !== 'default'
      ? options.activeProjectId
      : undefined;

  const parentProjectId =
    typeof options.parentId === 'string' && options.parentId.length > 0
      ? getProjectIdFromNodeId(options.parentId, normalizedActiveProjectId)
      : undefined;
  const normalizedParentProjectId =
    parentProjectId && parentProjectId !== 'default'
      ? parentProjectId
      : undefined;

  if (options.explicitProjectId) {
    return options.explicitProjectId;
  }

  if (normalizedParentProjectId) {
    return normalizedParentProjectId;
  }

  return options.hasMultipleVisibleProjects ? undefined : normalizedActiveProjectId;
}
